import React, { useEffect, useState } from 'react'
import Product from '../Product'
import axios from "../axios"
import { useParams } from 'react-router-dom/cjs/react-router-dom'
import ProductSkeleton from '../components/skeleton/ProductSkeleton'
import FilterModal from "../components/admin/FilterModal"
import { useStateValue } from '../StateProvider'

const SearchedProduct = () => {
  const params=useParams()
  const [{},dispatch]=useStateValue()
  const [products,setProducts]=useState([])
  const [loading,setLoading]=useState([false])
  const skeleton=[1,2,3,4]
  const [sortedData,setSortedData]=useState(products)

  useEffect(()=>{
    setSortedData(products)
  },[products])

  useEffect(()=>{
    return()=>{
      dispatch({
        type:"ADMIN_SEARCH_PRODUCTS",
        payload:[]
      })
    }
  },[])

    useEffect(()=>{
      setProducts([])
      setLoading(true)
      axios({
        url:'/products/search/product',
        method:'post',
        data:params
      }).then(res=>{
        setProducts(res.data);
        dispatch({
          type:'ADMIN_SEARCH_PRODUCTS',
          payload:res.data
        })
        setLoading(false)
      }).catch(err=>console.log(err))
    },[params.searchText])
    
  return (
    <div className='container-fluid' style={{minHeight:'60vh'}}>
      {sortedData.length>0&&
        <h5 className='mt-2'><FilterModal setSortedData={setSortedData}/>Products matching {params.searchText} ...</h5>
      }
      {!loading&&sortedData.length===0&&
      <h4 className='ml-5'>The product you are looking is not available, please check later. . .</h4>
      }
      <article className="row">  
                    {
                        sortedData.length>0&&
                        sortedData.map((f,i)=>
                            <article className='col-md-3 col-sm-4' key={i}>
                            <Product
                            id={f._id}
                            title={f.title}
                            price={f.price}
                            rating={f.rating}
                            image={f.image}
                            stock={f.stock}
                            active={f.active}
                            />
                              </article>
                        )
                    }
                    {
                      sortedData.length<=0&&loading&&
                      skeleton.map(s=>
                        <article className='col-md-3 col-sm-4' key={s}>
                            <ProductSkeleton />
                        </article>
                   )
                    }
            </article>
    </div>
  )
}

export default SearchedProduct
